import ct from "class-types.macro";
import React from "react";
import { NewItemsCategory } from "./NewItemsPageResult";
interface Props {
  popularCategories: NewItemsCategory[];
}
export default function NewItemsPopularCategories({
  popularCategories
}: Props) {
  return <div className={ct("container")} data-sentry-component="NewItemsPopularCategories" data-sentry-source-file="NewItemsPopularCategories.tsx">
      <div className={ct("flex", "flex-col", "flex-wrap", "justify-center", "-mt-32", "sm:flex-row")}>
        {popularCategories.map((category: NewItemsCategory) => <div className={ct("box-border", "flex", "flex-row", "p-3", "py-1", "sm:flex-col", "sm:py-3", "sm:w-3/6", "md:justify-center", "lg:flex-1", "lg:w-auto")}>
            {category.image && <a href={category.filterUrl} className={ct("bg-white", "border-gray-100", "rounded", "border-solid", "border", "flex", "flex-row", "items-center", "flex-grow", "p-3", "shadow-md", "sm:flex-col", "sm:justify-between", "md:p-6", "md:text-center")}>
                <img src={category.image} alt={category.name} className={ct("mr-4", "w-3/12", "sm:mx-auto", "sm:w-9/12")} aria-hidden="true" style={{
            maxWidth: "200px"
          }} />
                <div className="w-full">
                  <p className={ct("font-semibold", "text-xl", "mb-0", "text-gray-900")}>
                    {category.name}
                  </p>
                  <span className={ct("block", "text-sm")}>
                    {`Shop ${category.count} Product${category.count !== 1 ? "s " : " "}`}
                    <i className="icon-breadcrumb" />
                  </span>
                </div>
              </a>}
          </div>)}
      </div>
    </div>;
}